module.exports = __webpack_public_path__ + "static/media/combo_1.d0e46740.png";